export default "__VITE_ASSET__D_ONjop6__"